export default "__VITE_ASSET__D8BQ5btR__"